import * as Amplitude from '@amplitude/node';

const client = Amplitude.init(process.env.AMPLITUDE_KEY);

var amplitude = {
  trackLogin: trackLogin
};

function trackLogin(event_type, email) {
  client.logEvent({
    event_type: event_type,
    user_id: email
  });
}

export default amplitude;
